import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar, Modal} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, updateField} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import {CORRECT_TICKET_EVENT_INFORMATIONS_CMD_UPDATED, sendCorrectTicketEventInformationsCmd, updateCorrectTicketEventInformationsCmd, loadTicket} from '../actions'
import {CorrectTicketEventInformationsCmd} from '../models'
import i18n from '../i18n'

function correctTicketEventInformationsUpdate(event) {
    return {
        targetedEvent: event.processUid,
        text: undefined
    }
}

class CorrectTicketEventInformationsModal extends Component {
    static propTypes = {
        event: PropTypes.object.isRequired,
        onHide: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {dispatch, event} = this.props
        const update = correctTicketEventInformationsUpdate(event)

        dispatch(updateCorrectTicketEventInformationsCmd(update))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.event != this.props.event) {
            const {dispatch, event} = nextProps
            const update = correctTicketEventInformationsUpdate(event)

            dispatch(updateCorrectTicketEventInformationsCmd(update))
        }
    }

    _sendCmd() {
        const {dispatch, onHide} = this.props
        
        return dispatch(sendCorrectTicketEventInformationsCmd()).then(() => {
            return dispatch(loadTicket())
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, form, cmd, event, onHide, ...others} = this.props

        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.correctTicketEventInformations}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className='form-horizontal'>
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='textarea'
                            name='request'
                            label={i18n.text}
                            {...updateField(form.text(), event.data.message || event.data.comment)} />
                    </form>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.validate}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

CorrectTicketEventInformationsModal = connectForm({
    target: 'cmd',
    schema: CorrectTicketEventInformationsCmd.schema,
    action: CORRECT_TICKET_EVENT_INFORMATIONS_CMD_UPDATED
})(CorrectTicketEventInformationsModal)

CorrectTicketEventInformationsModal = connect((state) => ({
    cmd: state.ticket.correctTicketEventInformationsCmd
}))(CorrectTicketEventInformationsModal)

export default CorrectTicketEventInformationsModal


// WEBPACK FOOTER //
// ./lib/ticket/components/CorrectTicketEventInformationsModal.js